<script>
    import { sgettext } from '../../../i18n.js';
    export let row = null;
    export let getHyperlink = () => sgettext("$$DEFAULT_HYPERLINK$$");
    export let getLinkText = () => sgettext("$$DEFAULT_LINK_TEXT$$");
    export let openInNewTab = false;

    let hyperlink;
    $: hyperlink = getHyperlink(row);
    let linkText;
    $: linkText = getLinkText(row);
</script>

<a href={hyperlink} target={openInNewTab? "_blank" : "_self"}>{linkText}</a>